import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CoreProvider } from 'src/app/services/core';
import { LangProvider } from 'src/app/modules/lang/lang.provider';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
  styleUrls: ['settings.scss']
})
export class SettingsPage {

  langs = LangProvider.singleton.getLangArray();
  selectedLang = LangProvider.singleton.selectedLang;

  constructor(public navCtrl: NavController, public core: CoreProvider) {
  }

  languages = {
    title: this.core.lpipe.transform('Select your language'),
    mode: 'md'
  };

  onChangeLang(event) {
    LangProvider.singleton.setLanguage(event, async () => {
      localStorage.setItem('langCode', event.detail.value);
      (await this.core.alertCtrl.create({
        header: this.core.lpipe.transform('Changed languaje'),
        message: this.core.lpipe.transform('It\'s recomended reload app before using'),
        buttons: [
          {text: this.core.lpipe.transform('Continue')},
          {text: this.core.lpipe.transform('Reload'), handler: () => {
            location.reload();
          }}
        ]
      })).present();
    });
  }

}
